import {DocumentPreviewPage} from './DocumentPreviewPage';

export interface DocumentPreviewState {
  pages: DocumentPreviewPage[];
  activeIndex: number;
  isCollapsed: boolean;
}
